import { render, staticRenderFns } from "./ProducerReturnsComponent.vue?vue&type=template&id=29143c48&scoped=true"
import script from "./ProducerReturnsComponent.vue?vue&type=script&lang=js"
export * from "./ProducerReturnsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29143c48",
  null
  
)

export default component.exports